import React from 'react';

const Container = ({ props, children }) => (
    <div className="container-box">
        {children}
    </div>
);

export default Container;